export function parseJsonResponse(response) {
    return response
        .json()
        .catch(() => ({}))
        .then((data) => ({response, data}));
}

export function buildFormBody(payload) {
    const body = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, value]) => {
        body.append(key, value === null || value === undefined ? '' : String(value));
    });

    return body.toString();
}

export function isValidEmailOrPhone(value) {
    const normalizedValue = String(value || '');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /(.+)?([1-9][0-9][0-9]{7})/;

    return emailPattern.test(normalizedValue) || phonePattern.test(normalizedValue);
}

export function normalizePhoneOrEmail(value) {
    return String(value || '').replace(/[()\s]+/g, '');
}

export function validatePassword(password) {
    const passwordValue = String(password || '');
    if (!passwordValue) {
        return 'required';
    }

    if (passwordValue.length < 6) {
        return 'min';
    }

    if (passwordValue.length > 16) {
        return 'max';
    }

    if (!/^[A-Za-z0-9]+$/.test(passwordValue)) {
        return 'format';
    }

    return '';
}
